<template>

  <div class="col-lg-3">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <div class="mb-3">
      <div class="mb-3">
        <h3 class="d-inline">Messages</h3>
        <a href="javascript:void(0)" @click="open_new_box_popover">
          <i class="fas fa-plus-square ml-2"></i>
          créer un dossier
        </a>
      </div>

      <div v-if="new_box_popover_open" class="new-box-popover is-hidden" id="new_box_popover" style="display: block;">
        <form accept-charset="UTF-8" method="post" id="new_box_form">
          <div class="form-group">
            <input class="form-control" placeholder="Nommer la nouvelle boite" type="text" name="message_box[name]"
                   id="new_box_name" v-model="new_box_name">
            <div id="new_box_name_error_explanation" class="invalid-feedback"></div>
          </div>
          <button class="btn btn-secondary" type="button" @click="close_new_box_popover">Annuler</button>
          <button class="btn btn-primary" type="button" @click="add_box">Enregistrer</button>
        </form>
      </div>

      <article v-for="box in boxes" :key="box.id" class="mb-3">
        <div class="card card-frame p-3" @click="$emit('change_box', box.id)">
          <div class="media align-items-center">
            <div class="media-body mr-2">
              <h4 class="h6 mb-0">{{ box.name }}</h4>
            </div>
            <i @click="delete_box(box.id)" v-if="box.id > 3" class="fas fa-trash text-danger mr-2"></i>
            <i class="fas fa-angle-right"></i>
          </div>
        </div>
      </article>

    </div>
  </div>

</template>

<script>

export default {

  props: [
    'customer_id',
    'api_url',
  ],

  data: function () {
    return {
      message_type: "",
      message: String,
      new_messages_count: Number,
      boxes: Array,
      new_box_popover_open: Boolean,
      new_box_name: String
    }
  },

  mounted() {
    this.get_data()
    this.new_box_popover_open = false
    this.new_box_name = ""
    this.message = ""
  },

  // computed: {
  //   updated_boxes: {
  //     get() {
  //       return this.$store.state.updated_boxes
  //     },
  //     set(value) {
  //       this.$store.commit('updateList', value)
  //     }
  //   }
  // },

  methods: {

    close_message: function () {
      this.message = null;
    },

    add_box: async function () {

      const _this = this;

      let api_url = _this.api_url + "/message_boxes.json";
      let secure_key = await get_token();
      api_url += '?secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      const form_element = document.getElementById("new_box_form");
      const form_data = new FormData(form_element);
      form_data.append('message_box[position]', 1)

      axios({
        method: 'post',
        url: api_url,
        data: form_data,
        headers: { "cache-control": "no-cache" },
      })
          .then(function (response) {
            const status = response.data.status;

            if(status) {
              _this.new_box_popover_open = false
              _this.message = "Le dossier a été créé";
              _this.message_type = "alert-success"
            } else {
              _this.message = "Une erreur est survenue. Contactez votre support";
              _this.message_type = "alert-danger";
            }
          })
          .catch(function (error) {

            _this.errors = error;
            _this.message = "Une erreur est survenue. Contactez votre support";
            _this.message_type = "alert-danger";
          });
    },

    close_new_box_popover: function () {
      this.new_box_popover_open = false;
    },

    delete_box: async function (box_id) {
      const _this = this;
      let secure_key = await get_token();

      if (box_id < 4) {
        alert('Vous ne pouvez pas supprimer ce dossier')
        return
      }

      if (confirm('Attention, tous les messages du dossier seront supprimés')) {

        let api_url = _this.api_url + "/message_boxes/" + box_id +".json";
        api_url += '?secure_key=' + secure_key;
        api_url += '&customer_id=' + this.customer_id;

        axios({
          method: 'delete',
          url: api_url,
          headers: { "cache-control": "no-cache" },
        })
            .then(function (response) {
              _this.message = "Dossier supprimé";
              _this.message_type = "alert-success";
              _this.get_data()
            })
            .catch(function (error) {

              _this.errors = error;
              _this.message = "Une erreur est survenue. Contactez votre support";
              _this.message_type = "alert-danger";
            });
      }
    },

    open_new_box_popover: function () {
      this.new_box_popover_open = true;
    },

    get_data: async function () {

      const _this = this;
      let api_url = _this.api_url + "/messages/new_message_count.json";

      let secure_key = await get_token();
      api_url += '?secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      axios.get(api_url)
          .then(function (response) {
            _this.new_messages_count = response.data.new_message_count
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );

      api_url = _this.api_url + "/message_boxes.json";

      secure_key = await get_token();
      api_url += '?secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;

      axios.get(api_url)
          .then(function (response) {
            _this.boxes = response.data
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

  },
}
</script>

<style scoped>

.new-box-popover {
  width: 320px;
  position: absolute;
  top: 3rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, .25);
  box-shadow: 0 3px 10px rgba(0, 0, 0, .25);
  z-index: 1;
  background-color: #fff;
  padding: 1rem;
}
</style >
